<template>
	<div class="myBet-inner-content" >
		<div class="game_detail" v-for="(betslip, index) in betData" :key="index">
			<div class="top" :class="collapse_closed[betslip.betslip_id] !== true ? 'collapse-active' : ''">
				<div class="left inner-left">
					<div class="title">
						<div class="title-area-left" :style="betslip.is_mission_betslip ? gridColumns : ''">
								<div class="title-area-very-left-icons">
									<div @click="toggleFavourite(betslip.betslip_id)" v-if="betslip.favourite" class="pin-icon">
										<svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="15" height="15" viewBox="0 0 256 256" xml:space="preserve" style="rotate: 45deg; cursor: pointer;">
											<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;
												fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
												<path d="M 84.303 82.191 l -6.492 -6.492 l -6.492 -6.492 c -1.077 -1.087 -2.175 -2.153 -3.235 -3.257 c -0.016 -0.009 -0.031 -0.017
												-0.047 -0.025 l -2.154 -2.154 L 90 39.653 l -1.056 -1.056 c -9.367 -9.368 -23.457 -12.705 -36.139 -8.632 l -7.345 -7.344 c 0.929 -7.947
												-1.815 -15.958 -7.422 -21.565 L 36.983 0 L 0 36.982 l 1.057 1.056 c 5.606 5.606 13.614 8.353 21.565 7.422 l 7.345 7.345 c -4.073 12.681
												-0.737 26.772 8.631 36.139 L 39.653 90 l 24.117 -24.117 l 2.155 2.155 c 0.008 0.015 0.016 0.031 0.025 0.046 c 1.1 1.058 2.164 2.152 3.247
												3.226 l 8.081 8.081 l 0 0 l 4.912 4.912 l 3.246 3.246 c 1.403 0.761 2.796 1.532 4.302 2.19 c -0.658 -1.506 -1.429 -2.899 -2.19 -4.302 L
												84.303 82.191 z M 33.086 52.897 l 0.311 -0.886 l -9.714 -9.714 l -0.742 0.108 c -6.763 0.987 -13.633 -1.042 -18.681 -5.459 L 36.948 4.26
												c 4.415 5.047 6.447 11.92 5.458 18.68 l -0.108 0.742 l 9.714 9.714 l 0.886 -0.311 c 11.361 -3.984 24.084 -1.387 32.853 6.593 L 39.678 85.75
												C 31.698 76.981 29.102 64.254 33.086 52.897 z" style="stroke: none; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt;
												stroke-linejoin: miter; stroke-miterlimit: 10; fill: var(--primary); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) "
												stroke-linecap="round" />
											</g>
										</svg>
									</div>
									<div @click="toggleFavourite(betslip.betslip_id)" class="pin-icon" v-else >
										<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="15" height="15" viewBox="0 0 256 256" xml:space="preserve" style="rotate: 90deg; cursor: pointer;">
											<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;
												fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
												<path d="M 84.303 82.191 l -6.492 -6.492 l -6.492 -6.492 c -1.077 -1.087 -2.175 -2.153 -3.235 -3.257 c -0.016 -0.009 -0.031 -0.017
												-0.047 -0.025 l -2.154 -2.154 L 90 39.653 l -1.056 -1.056 c -9.367 -9.368 -23.457 -12.705 -36.139 -8.632 l -7.345 -7.344 c 0.929 -7.947
												-1.815 -15.958 -7.422 -21.565 L 36.983 0 L 0 36.982 l 1.057 1.056 c 5.606 5.606 13.614 8.353 21.565 7.422 l 7.345 7.345 c -4.073 12.681
												-0.737 26.772 8.631 36.139 L 39.653 90 l 24.117 -24.117 l 2.155 2.155 c 0.008 0.015 0.016 0.031 0.025 0.046 c 1.1 1.058 2.164 2.152 3.247
												3.226 l 8.081 8.081 l 0 0 l 4.912 4.912 l 3.246 3.246 c 1.403 0.761 2.796 1.532 4.302 2.19 c -0.658 -1.506 -1.429 -2.899 -2.19 -4.302 L
												84.303 82.191 z M 33.086 52.897 l 0.311 -0.886 l -9.714 -9.714 l -0.742 0.108 c -6.763 0.987 -13.633 -1.042 -18.681 -5.459 L 36.948 4.26
												c 4.415 5.047 6.447 11.92 5.458 18.68 l -0.108 0.742 l 9.714 9.714 l 0.886 -0.311 c 11.361 -3.984 24.084 -1.387 32.853 6.593 L 39.678 85.75
												C 31.698 76.981 29.102 64.254 33.086 52.897 z" style="stroke: none; stroke-width: 2; stroke-dasharray: none; stroke-linecap: butt;
												stroke-linejoin: miter; stroke-miterlimit: 10; fill: var(--white); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) "
												stroke-linecap="round" />
											</g>
										</svg>
									</div>
									<div v-if="loading_states[betslip.betslip_id]" class="loader-main"></div>

								</div>
								<div class="title-area-left-icons">
									<img v-if="betslip.is_mission_betslip" src="/assets/white_sport_icons/Archery.svg" width="15" height="15" alt="" @click="Betslip_closed(betslip.betslip_id)" style="cursor: pointer;">
									<div style="min-width: 150px;">
										<p @click="Betslip_closed(betslip.betslip_id)" style="cursor: pointer;">{{ betslip.betslip_type_lang }}</p>
										<div @click="copyId(betslip.betslip_id)" class="betslip-id-container">
											<span class="betslip-id-text" style="font-weight: 300; font-size: 12px;">{{ t('account.affiliate.id')}}: {{ betslip.betslip_id }}</span>
											<div v-if="copied_id != betslip.betslip_id">
												<i class="fa fa-clone copy-btn" aria-hidden="true" style="font-size: 10px;"></i>
											</div>
											<div v-if="copied_id == betslip.betslip_id">
												<i class="fa fa-check success-btn" aria-hidden="true" style="font-size: 10px;"></i>
											</div>
										</div>
									</div>
								</div>

								<div class="title-area-right-content">
									<span v-if="betslip.is_acca" class="dropdown-acca-boost-icon">
										<img :src="accaBoostIcon" alt="acca-boost" class="acca-boost-icon">
									</span>
									<template v-if="betslip.settlement || betslip.cashout_at">
										<p v-if="betslip.settlement == 'LOST' || betslip.settlement == 'HALF_LOST'" style="cursor: pointer; color: var(--red);" @click="Betslip_closed(betslip.betslip_id)">{{ betslip.settlement }}</p>
										<p v-if="betslip.settlement == 'WON' || betslip.settlement == 'HALF_WON'" style="cursor: pointer; color: var(--primary);" @click="Betslip_closed(betslip.betslip_id)">{{ betslip.settlement }}</p>
										<p v-if="betslip.settlement == 'PUSH' || betslip.settlement == 'CANCELED' || betslip.settlement == 'REFUND'" style="cursor: pointer;" @click="Betslip_closed(betslip.betslip_id)">{{ betslip.settlement }}</p>
										<p v-if="betslip.cashout_at" style="cursor: pointer;">Cashed Out</p>
									</template>
								</div>
						</div>
						<div class="collapse-ico" @click="Betslip_closed(betslip.betslip_id)">
							<svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="7.414" viewBox="0 0 13.414 7.414">
								<g id="Group_165" data-name="Group 165" transform="translate(1676.207 587.207) rotate(180)">
									<line id="Line_5" data-name="Line 5" x2="6.034" y2="6" transform="translate(1663.5 580.5)" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-width="1" />
									<line id="Line_6" data-name="Line 6" x1="6.034" y2="6" transform="translate(1669.466 580.5)" fill="none" stroke="var(--white)" stroke-linecap="round" stroke-width="1" />
								</g>
							</svg>
						</div>
					</div>

					<div class="myBets-items" v-for="bet in betslip.bets" :key="bet.id" @click="goToFixture(bet)" style="cursor:pointer;">
						<div class="top single-settled-top">
							<div v-if="bet.settlement">
								<img v-if="bet.settlement == 'WON' || bet.settlement == 'HALF_WON'" src="@/assets/images/light_circle_img.png" alt="WON">
								<img v-if="bet.settlement == 'LOST' || bet.settlement == 'HALF_LOST'" src="@/assets/images/pink_circle_img.png" alt="LOST">
								<img v-if="bet.settlement == 'PUSH' || bet.settlement == 'CANCELED' || bet.settlememt == 'REFUND'" src="@/assets/images/yellow_circle_img.png" alt="PUSH OR CANCELLED">
							</div>
							<div class="warning-ico" v-else>
								<img v-if="!bet.settlement && !bet.current_price" src="/assets/icons/warning.svg" width="16">
							</div>
							<div class="left">
								<div class="title">
									<div class="title-info">
										<span v-if="bet.live == true" class="btp-live">
											<div class="live-badge" v-html="svg_data.live_badge"></div>
										</span>
										<div class="btp-hour">
											<div class="btp-hour-inn">
												<template v-if="bet.live == true">
													<span v-if="liveSportsStore.hasFixtureClock(bet.sport_id)">{{ myBetsStore.fixtureClockTime(bet.statistics)}} {{ myBetsStore.fixtureState(bet.statistics)}}</span>
													<span v-else>{{ myBetsStore.fixtureState(bet.statistics)}}</span>
													<span class="btp-hours-progress">
														<span class="btp-progress-bar"></span>
													</span>
												</template>
												<template v-else>
													<span>{{ bet.market_name }}
												</span>
												</template>
											</div>
										</div>
									</div>
									<span>{{bet.market_name }}</span>
									<p class="btp-title">{{ bet.odd_name }}</p>
								</div>
							</div>

							<div class="right">
								<div class="rate">
									{{ bet.sp ? bet.placeholder : oddsStore.oddsFormat(bet.odd_price) }}
								</div>
							</div>

						</div>

						<div class="asia">
							<div class="icon">
								<img :src="liveSportsStore.liveSportWhiteIcon(bet.sport_id)" alt="card-image">
							</div>
							<div class="betSlip-live">
								<div class="detail">
									<p class="ad-tittle-top">{{ bet.region_name }} - {{ bet.competition_name }}</p>
									<p v-if="liveSportsStore.hasOneParticipant(bet.sport_id) || participantsSame(bet)" class="ad-tittle-btm">{{ bet.participants[0] }}</p>
									<p v-else class="ad-tittle-btm"><span>{{ bet.participants[0] }}</span> vs <span>{{ bet.participants[1] }}</span></p>
								</div>

							<div class="live-score" v-if="bet.live">
								<template v-if="liveSportsStore.hasOneParticipant(bet.sport_id) || participantsSame(bet)">
									<span v-if="bet.statistics">{{ bet.statistics.p1_score }}</span>
								</template>
								<template v-else>
									<span v-if="bet.statistics">{{ bet.statistics.p1_score }}</span>

									<span v-if="bet.statistics">{{ bet.statistics.p2_score }}</span>
								</template>
							</div>

							<div class="date-time" v-else>
								<p class="date">{{ datesStore.preFixtureBookDate(bet.event_datetime) }}</p>
								<p class="time">{{ datesStore.preFixtureBookTime(bet.event_datetime) }}</p>
							</div>

							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="bottom">
				<div class="reuturn">
					<div v-if="betslip.is_acca" class="acca-boost">
						<div class="acca-boost-bet">
							<div class="acca-boost-bonus">
								<img :src="accaBoostIcon" alt="acca-boost" class="acca-boost-icon">
								<p>{{ $t('betslip.acca_bonus', {bonusValue: myBetsStore.getMyBetsScale(betslip.bets).boost_percentage }) }}</p>
							</div>
							<div class="right_content_85 text-white">
								<p>+ {{ currenciesStore.format_currency(betslip.acca_possible)}}</p>
							</div>
						</div>
					</div>
					<div class="stake" v-if="betslip.betslip_stake > 0">
						<p> {{ $t('betslip.stake') }}:</p>
						<p :class="{ 'free_bet' : betslip.freebet_id > 0}"><span><svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 20.311 19.001"><g id="Group_1760" data-name="Group 1760" transform="translate(8326.008 8556.914)"><g id="g313" transform="translate(-8325.508 -8552.801)"><path id="path315" d="M-25.358,0H-41.4a1.636,1.636,0,0,0-1.636,1.636V3.924h19.311V1.636A1.636,1.636,0,0,0-25.358,0Z" transform="translate(43.033)" fill="none" stroke="var(--light-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"></path></g><path id="path317" d="M21.943-29.062H5.578V-18.6H21.943Z" transform="translate(-8329.613 -8519.814)" fill="none" stroke="var(--light-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"></path><g id="g319" transform="translate(-8315.853 -8552.801)"><path id="path321" d="M0,0V14.388" fill="none" stroke="var(--light-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"></path></g><g id="g323" transform="translate(-8315.853 -8556.414)"><path id="path325" d="M-5.817-5.185H-9.871l2.743-3.032A1.768,1.768,0,0,1-5.817-8.8,1.766,1.766,0,0,1-4.05-7.033v.082A1.766,1.766,0,0,1-5.817-5.185Z" transform="translate(9.871 8.798)" fill="none" stroke="var(--light-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"></path></g><g id="g327" transform="translate(-8321.674 -8556.414)"><path id="path329" d="M-2.536-5.185H1.519L-1.225-8.217A1.768,1.768,0,0,0-2.536-8.8,1.766,1.766,0,0,0-4.3-7.033v.082A1.766,1.766,0,0,0-2.536-5.185Z" transform="translate(4.303 8.798)" fill="none" stroke="var(--light-gray)" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"></path></g></g></svg></span> {{ currenciesStore.format_currency(betslip.betslip_stake)  }}</p>
					</div>
					<div class="stake" v-if="betslip.bonus_stake > 0">
						<p>{{ $t('betslip.bonus_stake') }}:</p>
						<p>{{ currenciesStore.format_currency(betslip.bonus_stake) }}</p>
					</div>

					<div v-if="!myBetsStore.hasSPOdd(betslip)" class="return">
						<p>{{ $t('betslip.to_return') }}:</p>
						<p>{{ currenciesStore.format_currency(betslip.to_return)  }}</p>
					</div>
					<div class="return" v-if="betslip.settlement || betslip.cashout_at">
						<p>{{ $t('my_bets.returned') }}</p>
						<p>{{ currenciesStore.format_currency(betslip.returned)  }}</p>
					</div>
				</div>
			</div>
			<div class="cashout-btn-outer" v-if="betslip.cashout_available && (betslip.mission_can_cashout == null || betslip.mission_can_cashout == true) && myBetsStore.checkCashoutEligibility(betslip)">
				<CashOut :betslip="betslip" />
			</div>
			<div v-else-if="betslip.cashout_at == null && betslip.betslip_result == 'settled'" >
			</div>
			<div v-else-if="betslip.cashout_at == null && betslip.settled_at == null" class="cashout-btn-outer">
				<a href="javascript:void(0);" class="btn-small-disabled" disabled>{{ $t('betslip.no_cashout_available') }}</a>
			</div>
			<div
				class="mybets-actions-row"
				:style="{ gridTemplateColumns: `repeat(${getActionButtonsCount(betslip)}, minmax(0, 1fr))` }"
			>
				<button v-if="hasAvailableRebet(betslip)" type="button" class="mybets-action-btn" @click="rebetBetslip(betslip)">
					<img src="/assets/images/rebet.svg" alt="refresh" class="mybets-action-icon mybets-action-icon--img">
					<span>Rebet</span>
				</button>
				<button type="button" class="mybets-action-btn" @click="showShareModal(betslip)">
					<span class="mybets-action-icon mybets-action-icon--svg" v-html="svg_data.share_ico"></span>
					<span>{{ $t('general.share') }}</span>
				</button>
				<button
					v-if="betslipStore.isBetslipEditable(betslip)"
					type="button"
					class="mybets-action-btn"
					@click="openEditBetModal(betslip)"
				>
					<img src="/assets/images/edit.svg" alt="edit" class="mybets-action-icon mybets-action-icon--img">
					<span>Edit</span>
				</button>
			</div>
		</div>
	</div>
</template>
<script setup>
 /* eslint-disable */
import { ref, onMounted, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useDatesStore } from '@/stores/dates';
import { useCurrenciesStore } from '@/stores/currencies';
import { useLanguagesStore } from '@/stores/languages';
import { MyBets } from '@/stores/MyBets';
import { useLiveSportsStore } from '@/stores/live_sports';
import moment from 'moment';
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import { useOddsStore } from '@/stores/odds';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import CashOut from './CashOut.vue';
import accaBoostIcon from "@/assets/svgs/acca_boost.svg"
import EditBet from '@/components/modals/edit_bet/EditBet.vue';
import { openModal } from '@kolirt/vue-modal';
import { BetSlip } from '@/stores/BetSlip';
import ShareBet from '@/components/modals/share_bet/ShareBetModal.vue';
import { useSharedBetslipsStore } from '@/stores/shared_betslips';

const collapse_closed = ref({});
const oddsStore = useOddsStore();
const datesStore = useDatesStore();
const currenciesStore = useCurrenciesStore();
const languagesStore = useLanguagesStore();
const myBetsStore = MyBets();
const liveSportsStore = useLiveSportsStore();
const router = useRouter();
const { t } = useI18n();
const betslipStore = BetSlip();
const sharedBetslipStore = useSharedBetslipsStore();

const props = defineProps({
	betData: {
		required: true,
	},
});

const svg_data = ref(commonSvgs);
const copied_id = ref(null);
const partial_cashout = ref(0);
const loading_states = ref({});
const share_url = ref(null);
const share_id = ref(null);

const buildShareUrl = (code) => {
	if (!code) return null;
	return `${process.env.VUE_APP_URL}/share/betslip/${code}`;
};

const getExistingSharedData = (betslip) => {
	if (betslip.shared_betslip_code) {
		return { share_id: betslip.shared_betslip_code, share_url: buildShareUrl(betslip.shared_betslip_code) };
	}

	return null;
};

const participantsSame = (bet) => {
	if (bet.participants[0] == bet.participants[1]) return true;
	return false;
}

const isBetRebetAvailable = (bet) => {
	return Boolean(
		bet?.uuid &&
		bet?.fixture_id &&
		!bet?.settlement &&
		bet?.status === 'available'
	);
};

const hasAvailableRebet = (betslip) => {
	if (!betslip || !Array.isArray(betslip.bets) || betslip.bets.length === 0) return false;
	return betslip.bets.some((bet) => isBetRebetAvailable(bet));
};

const getActionButtonsCount = (betslip) => {
	let count = 1;
	if (hasAvailableRebet(betslip)) count += 1;
	if (betslipStore.isBetslipEditable(betslip)) count += 1;
	return count;
};

const goToFixture = (bet) => {
	if (bet.live) {
		router.push({'name': 'live-sports-eventview', params: {'fixture_id': bet.fixture_id} });
	} else {
		if (moment(bet.event_datetime).isAfter(moment.now())) {
			router.push({ name: 'pre-sports-fixturebook', params: { sport_id: bet.sport_id, region_id: bet.region_id, competition_id: bet.competition_id, fixture_id: bet.fixture_id } } )
		}
	}
}

// Toggle Favourite
const toggleFavourite = (betslip_id) => {
	myBetsStore.toggleFavourite(betslip_id);
};

const Betslip_closed = (betslip_selected_id) => {
	if(collapse_closed.value[betslip_selected_id]){
		delete collapse_closed.value[betslip_selected_id]
	}
	else{
		collapse_closed.value[betslip_selected_id]= true
	}
};

// create computed to change the grid template collumns if betslip is mission
const gridColumns = computed(() => {
	return { display: 'grid', gridTemplateColumns: 'auto auto auto 1fr', gap: '6px', alignItems: 'center'}
});

// update background of cashout range
const updateBackground = (event) => {
	const min = event.target.min;
	const max = event.target.max;
	const val = event.target.value;

	const percentage = ((val - min) / (max - min)) * 100;

	event.target.style.background = `linear-gradient(to right, var(--secondary) ${percentage}%, var(--light-dark) ${percentage}%)`;
};

// update background of cashout range
watch(partial_cashout, (newValue) => {
	const inputElement = document.querySelector('.cashout-range');
	updateBackground({ target: inputElement });
});

const openEditBetModal = (betslip) => {
	document.body.classList.remove('betslip-show');
	betslipStore.is_betslip_opened = false;
	betslipStore.betSlipModel = '';
	openModal(EditBet, {betslip: betslip}).then(() => {}).catch(() => { });
}

const copyId = (betslip_id) => {
	navigator.clipboard.writeText(betslip_id).then(() => {
		copied_id.value = betslip_id;
		setTimeout(() => {
			copied_id.value = null;
		}, 800);
	}).catch(() => {
		console.error('Failed to copy text');
	});
}

const showShareModal = (betslip) => {
	const existingShared = getExistingSharedData(betslip);
	if (existingShared?.share_url && existingShared?.share_id) {
		openModal(ShareBet, {
			share_url: existingShared.share_url,
			share_id: existingShared.share_id,
			betslip: betslip,
			is_placed: true,
		}).catch(() => {});
		return;
	}

 	let data = [];
	loading_states.value[betslip.betslip_id] = true;

	for (const index in betslip.bets) {
		const bet = betslip.bets[index];

		data.push({
			bet_uuid: bet.uuid,
			fixture_id: bet.fixture_id
		});
	};

	sharedBetslipStore.storeSharedBetslip(JSON.stringify(data), betslip.betslip_type, betslip.betslip_id).then((response) => {
		loading_states.value[betslip.betslip_id] = false;
		share_url.value = response.message;
		share_id.value = response.code;

		betslip.can_share = false;
		betslip.shared_betslip_code = response.code;
		// betslipStore.is_betslip_opened = false;
		// betslipStore.betSlipModel = '';

		openModal(ShareBet , { share_url: buildShareUrl(share_id.value), share_id: share_id.value, betslip: betslip, is_placed: true }).then((data) => {

			// Commenting out or removing the condition to show the register modal
			// if (data.show_register) showRegisterModal();
		}).catch((error) => {
			console.log(error)
		});

	}).catch((error) => {
		loading_states.value[betslip.betslip_id] = false;
	})

};

const rebetBetslip = async (betslip) => {
	if (!hasAvailableRebet(betslip)) return;
	betslipStore.resetBetslip();

	for (const bet of betslip.bets) {
		if (!isBetRebetAvailable(bet)) continue;
		try {
			await betslipStore.toggleToBetslip({
				odd_uuid: bet.uuid,
				fixture_id: bet.fixture_id
			});
		} catch (error) {
			//
		}
	}

	betslipStore.betSlipModel = 'betslip';
};

</script>

<style scoped>
.mybets-betslips {
	max-height: 600px;
	overflow-y: auto;
}

.game_detail {
	border: 1px solid var(--tab-gray) !important;
	border-radius: 4px;
	overflow: hidden;
	background: var(--light-dark);
	margin: 0 10px 10px !important;
	padding: 0 !important;
}

.game_detail > .top {
	margin-top: 0 !important;
	/* border-bottom: 1px solid var(--tab-gray); */
}

.game_detail > .top .inner-left {
	border-radius: 0;
	padding: 12px 12px;
}

.game_detail > .collapse-active .inner-left .title{
	border-bottom: 1px solid var(--tab-gray);
}

.game_detail .title-area-left {
	gap: 8px;
	align-items: stretch;
}

.game_detail .collapse-ico {
	border-left: 1px solid var(--tab-gray);
	min-width: 24px;
	padding-left: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	align-self: stretch;
}

html[dir="rtl"] .game_detail .collapse-ico {
	border-right: 1px solid var(--tab-gray);
	border-left: 1px solid transparent;
}

.game_detail .collapse-ico svg {
	width: 10px;
}

.mybets-actions-row {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	border-top: 1px solid var(--tab-gray);
}

html[dir="rtl"] .mybets-action-btn {
	border-right: 1px solid transparent;
	border-left: 1px solid var(--tab-gray);
}

.mybets-action-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	padding: 10px 8px;
	background: transparent;
	border: none;
	color: var(--off-light-gray);
	border-right: 1px solid var(--tab-gray);
	cursor: pointer;
	font-size: 12px;
	line-height: 1;
	transition: background 0.2s ease, color 0.2s ease;
}

.mybets-action-btn:last-child {
	border-right: none;
}

.mybets-action-btn:not(:disabled):hover {
	background: var(--secondary);
	color: var(--dark);
}

.mybets-action-btn:not(:disabled):hover .mybets-action-icon--img {
	filter: brightness(0) saturate(100%);
}

.cashout-btn-outer {
	padding: 0 10px 8px;

}

.game_detail .bottom {
	padding: 0 12px 10px !important;
	border-top: 1px solid var(--tab-gray);

}

.game_detail .bottom .reuturn {
	padding: 12px 0 0 !important;
	margin: 0 !important;
}

.game_detail .bottom .reuturn .stake,
.game_detail .bottom .reuturn .return {
	display: grid;
	grid-template-columns: 1fr auto;
	padding: 0;
}

.game_detail .bottom .reuturn .stake p,
.game_detail .bottom .reuturn .return p {
	margin: 0;
	padding-top: 2px;
}

.mybets-action-btn:disabled {
	opacity: 0.6;
	cursor: default;
}

.mybets-action-icon {
	font-size: 12px;
	width: 12px;
	height: 12px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.mybets-action-icon--svg :deep(svg) {
	width: 12px;
	height: 12px;
}

.mybets-action-icon--img {
	width: 12px;
	height: 12px;
	object-fit: contain;
	filter: brightness(1.15);
}

.game_detail .myBets-items .single-settled-top .left .title {
	border-bottom: none !important;
}

.eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top .inner-left  {
	padding: 0px 0px 0px !important;
}

.eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .asia {
	padding: 3px 0px 8px 0px;
}

.eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top .title .collapse-ico {
	padding-right: 10px;
}

.eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top.collapse-active .inner-left .myBets-items {
	padding: 0px 12px !important;
	padding-top: 10px !important;
}

.mybets-action-btn:not(:disabled):hover .mybets-action-icon--svg :deep(svg *) {
	fill: var(--dark) !important;
	stroke: var(--dark) !important;
}


@media screen and (min-width: 320px) and (max-width: 767px) {
	.mybets-betslips {
		max-height: calc(100vh - 220px);
	}
}

.mybets-betslips::-webkit-scrollbar {
  width: 3px;
}

.mybets-betslips::-webkit-scrollbar-thumb {
  background-color: var(--primary);
  border-radius: 2px;
  border: 3px solid linear-gradient(var(--primary) 0%, var(--primary) 100%);
}


.btn-small-disabled {
	color: var(--tab-gray);
	border: 1px solid var(--tab-gray);
	text-decoration: none;
	text-align: center;
	width: 100%;
	display: block;
	cursor: pointer;
	max-width: 100%;
	margin: 0 auto;
	font-size: 12px;
	font-weight: 700;
	border-radius: 5px;
	padding: 9.5px 20px;
	box-sizing: border-box;
	transition: all 0.5s;
	text-transform: uppercase;
	cursor: default !important;
	pointer-events: none;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.btn-small-disabled {
		margin-top: 12px;
	}
}
.grid-columns {
	display: grid;
	grid-template-columns: 40px auto 1fr;
	gap: 2%;
	align-items: center;
}

.eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top.single-settled-top .btp-hour .btp-hour-inn p {
	font-size: 12px;
	font-weight: 400;
	color: var(--primary);
	text-overflow: ellipsis;
	overflow: hidden;
}
/* .eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top.single-settled-top .btp-hour .btp-hour-inn span {
    height: 3px;
    background: var(--tab-gray);
    width: 100%;
    display: block;
    margin: 0px auto;
    position: relative;
} */
/* .eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top.single-settled-top .btp-hour .btp-hour-inn span:before {
	content: "";
	background: var(--secondary);
	width: 100%;
	height: 100%;
	position: initial;
	left: 0;
	top: 0;
	display: block;
	background: linear-gradient(var(--secondary), var(--secondary)) left/0% 100% no-repeat;
	animation: live-animation 0.6s ease-in-out infinite alternate;
	-webkit-animation: live-animation 0.6s ease-in-out infinite alternate;
} */

.eventime_mobal_content .my_bet_wrap .my_bet_game .myBet-inner-content .game_detail .top.single-settled-top .btp-title {
	padding-top: unset;
	padding-bottom: 3px;
}

.title-area-left-icons {
	align-items: center;
	gap: 6px;
}

.title-area-left {
	align-items: center;
}

.copy-btn {
	cursor: pointer;
	color: var(--off-light-gray);
	font-size: 12px;
}

.success-btn {
	cursor: pointer;
	color: var(--primary);
	font-size: 12px;
}

.betslip-id-container {
	display: flex;
	align-items: center;
	gap: 7px;
	max-width: 150px;
}

.betslip-id-text {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: calc(100% - 30px);
	cursor: pointer;
}

.title-area-very-left-icons {
	display: flex;
	flex-direction: column;
	row-gap: 6px;
	justify-content: center;
	align-items: center;
	align-content: center;
	align-self: stretch;
	padding-right: 8px;
	margin-right: 8px;
	padding-top: 2px;
	padding-bottom: 2px;
	border-right: 1px solid var(--tab-gray);
	padding-left: 12px;
}

html[dir="rtl"] .title-area-very-left-icons {
	border-left: 1px solid var(--tab-gray);
	border-right: 1px solid transparent;
}

.share-icon {
	cursor: pointer;
	width: 13px;
	height: 14px;
}

.loader-main {
	width: 13px;
	height: 13px;
	border-radius: 50%;
	position: relative;
}

.title-area-right-content {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 6px;
	margin-left: auto;
}

.title-area-right-content p {
	margin: 0;
	font-weight: bold;
}

.dropdown-acca-boost-icon {
	padding: 0 0.25rem 0;
	display: inline-flex;
	align-items: center;
}

.acca-boost-icon {
	width: 20px;
	height: 20px;
}
</style>